import { render, staticRenderFns } from "./DataDetailsModal.vue?vue&type=template&id=24c793b1&scoped=true&"
import script from "./DataDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./DataDetailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c793b1",
  null
  
)

export default component.exports